import React from "react";
import NaytaPaluuNappi from "./NaytaPaluuNappi";

export default function Sanasto() {
  return (
    <div>
      <NaytaPaluuNappi kohde={-1} />
      <br />
      <h1>Termit</h1>
      <h2>Lentonumerot</h2>
      <p>
        Lentonumerot kuvaavat kiekon lento-ominaisuuksia, jotka ovat
        <strong> nopeus</strong>,<strong> liito</strong>,
        <strong> lento-</strong> ja <strong>loppuvakaus</strong>. Vakaudella
        viitataan kiekon kaartoon kiertosuuntaansa ennen loppulentoa. Näin esim.
        myötäpäivään pyöriessään kiekko pyrkii kaartamaan oikealle. Termeillä{" "}
        <strong>ylivakaa</strong> (overstable) ja <strong>alivakaa</strong>{" "}
        (understable) tarkoitetaan kiekkoja, jotka kaartavat kiertosuuntaansa
        (ylivakaa) tai sitä vastaan (alivakaa). <strong>Suora </strong>
        (straight) taas viittaa lentorataan, joka toki myös kaartaa, mutta
        kaartaa myös takaisin, eli laskeutuu heiton suunnassa.
      </p>
      <p>
        <strong>Nopeus</strong> (speed): Ensimmäisen eli nopeusnumeron arvo on
        välillä 1-14 ja sillä tarkoitetaan suositeltua suhteellista nopeutta,
        jolla kiekkoa tulee heittää, jotta se käyttäytyisi muiden
        lentonumeroiden mukaisella tavalla. Mikäli kiekkoa heittää kovempaa (tai
        hiljempaa), se kaartaa enemmän (tai vähemmän) kuin vakausnumerot antavat
        ymmärtää.
      </p>
      <h3>Kiekkotyypit nopeuden mukaan</h3>
      <ul>
        <ul>
          <strong>Pitkän matkan kiekko</strong> (draiveri, driver): nopeus 8-13,
          ohut ja teräväreunainen
        </ul>
        <ul>
          <strong>Keskipitkän matkan kiekko</strong> (fairway driver): nopeus
          6-8
        </ul>
        <ul>
          <strong>Lähestymiskiekko</strong> (midari, mid-range): nopeus 3-5
        </ul>
        <ul>
          <strong>Putteri</strong> (putter): nopeus 1-3, paksu ja
          tylppäreunainen
        </ul>
      </ul>
      <p>
        <strong>Liito</strong> (glide): Toisen eli liitonumeron arvo on välillä
        1 - 7 ja se kuvaa kiekon lennon pituutta nopeusnumeron mukaisesti
        heitettynä. Mitä suurempi numero, sitä pitempään kiekko pyrkii pysymään
        ilmassa.
      </p>
      <p>
        <strong>Vakaus</strong> (turn, kääntyminen): Kolmannen eli vakausnumeron
        arvo on välillä -5 - +1 ja se kertoo kuinka paljon kiekko kaartaa
        kiertosuuntaansa lennon aikana ennen loppulentoa. Mitä negatiivisempi
        numero, sitä enemmän kaartaa, ja positiivinen numero kääntää kaarron
        jopa lievästi toiseen suuntaan.
      </p>
      <p>
        <strong>Loppuvakaus</strong> (fade, feidi): Neljännen eli
        loppuvakausnumeron arvo on välillä 0 - 5 ja mitä suurempi numero on,
        sitä enemmän kiekko kaartaa lennon lopussa kiertosuuntaansa vastaan.
      </p>
      <h3>Muovit</h3>
      <strong>High Performance</strong>: Kestävä muovi, joka säilyttää
      lento-ominaisuutensa pitkään ja jämäkkyytensä ansiosta lentää vakaasti.
      Säilyttää ominaisuutensa pitkään!
      <br />
      Kestävyys (1-3): 3, Pito (1-5): 2<br />
      <br />
      <strong>Flex Performance</strong>: Ominaisuuksiltaan kuten High
      Performance -muovi, mutta joustavavampi. Sen vuoksi siitä saa pitävän
      otteen. Sen kestävyys ja pito ovat täydellisessä suhteessa.
      <br />
      Kestävyys (1-3): 3, Pito (1-5): 3<br />
      <br />
      <strong>Grip Performance</strong>: Hyvä perusmuovi, joka soveltuu
      loistavasti puttereihin, mutta myös keveytensä ansiosta pitkiin heittoihin
      saa helposti lisää metrejä. Tämä muovi on alottelijalle hyvä valinta.
      Joustavuutensa ansiosta siitä saa pitävän otteen.
      <br />
      Kestävyys (1-3): 1, Pito (1-5): 4<br />
      <br />
      <strong>Elastic Performance</strong>: Supertaipuisa muoviseos, joka
      johonkin osuessaan ei pompi ja kieriikin huonosti.
      <br />
      Kestävyys (1-3): 2, Pito (1-5): 5<p>Näin taipuisa on Elastic Ogopogo!</p>
      <img src="/ogopogo2_300.webp" alt="Kuva" />
      <br />
      &nbsp;
    </div>
  );
}
